// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__3GiQO","summary":"CartItem_summary__3NWFv","price":"CartItem_price__3mIwI","amount":"CartItem_amount__6x3lc","actions":"CartItem_actions__3k9Rv"};